import { downloadAxiosResponse } from '@cibo/ui'
import { AxiosError } from 'axios'
import { useState } from 'react'
import { AgreementsAPI } from '../api'

export const useDownloadAttachment = (onError?: (err: AxiosError) => void) => {
  const [downloading, setDownloading] = useState(false)

  const openFile = (agreementId: string, fileId: string) => () => {
    setDownloading(true)

    AgreementsAPI.getAttachment(agreementId, fileId)
      .then(downloadAxiosResponse())
      .catch(onError)
      .finally(() => setDownloading(false))
  }

  return { openFile, downloading }
}
